<template>
    <div>
        <b-button @click="visible = !visible" class="w-100 mb-1"
                  variant="outline-secondary">
            <i class="fa-solid fa-download"></i>
            {{ $t('action-items.passive-transport') }}
        </b-button>
        <b-collapse v-model="visible" class="mt-2 mb-2 w-100">
            <b-list-group-item>
                <b-form>
                    <b-form-group id="input-group-1-passivecheck" label="Status:"
                                  label-for="input-passive">
                        <b-form-select
                            id="input-passive"
                            v-model="checkForm.state"
                            :options="checkForm.options"
                            required
                        ></b-form-select>
                    </b-form-group>
                    <b-form-group
                        id="input-group-1-passiveCheck"
                        :label="$t('forms.message')"
                        label-for="textarea-passive">
                        <b-form-textarea v-model="v$.checkForm.comment.$model"
                                         :class="{ 'is-invalid': v$.checkForm.$error }"
                                         id="textarea-passive"
                                         placeholder="Comment for passive check"
                                         rows="3"
                                         max-rows="6"
                        ></b-form-textarea>
                        <div class="invalid-feedback" v-if="v$.checkForm.comment.required">{{ $t('Field is required') }}
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group">
                        <b-form-checkbox
                            v-model="checkForm.forceHardstate"
                            id="checkboxes-custom-notification"
                            name="checkboxes-custom-notification">
                            Force to hard State
                        </b-form-checkbox>
                    </b-form-group>
                    <b-button variant="success" @click="passiveCheck" class="w-100">{{ $t('forms.send-command') }}
                    </b-button>
                </b-form>
            </b-list-group-item>
        </b-collapse>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'


export default {
    name: "PassiveCheck",
    props: [
        'uuids',
        'servicestatus'
    ],
    data(){
        return {
            visible: false,
            checkForm: {
                state: 0,
                options: [
                    {value: 0, text: 'ok'},
                    {value: 1, text: 'warning'},
                    {value: 2, text: 'critical'},
                    {value: 3, text: 'unknown'}
                ],
                comment: 'Passive check',
                forceHardstate: false,
            },
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        checkForm: {
            comment: {
                required,
            }
        }
    },
    methods: {
        async passiveCheck(){
            this.v$.checkForm.$touch();
            const validated = await this.v$.checkForm.$validate();
            if(!validated){
                return;
            }
            let externalCommands = [];
            externalCommands.push({
              /*  command: 'PROCESS_SERVICE_CHECK_RESULT',
                serviceUuid: this.uuids.serviceuuid,
                hostUuid: this.uuids.hostuuid,
                status_code: this.checkForm.state,
                plugin_output: this.checkForm.comment,
                long_output: '', */

                command: 'commitPassiveServiceResult',
                hostUuid: this.uuids.hostuuid,
                serviceUuid: this.uuids.serviceuuid,
                status_code: this.checkForm.state,
                plugin_output: this.checkForm.comment,
                forceHardstate: this.checkForm.forceHardstate,
                maxCheckAttempts: 10
            });
           /* if(this.checkForm.forceHardstate){
                for ( let i=0; i<2; i++ ) {
                    externalCommands.push({
                        command: 'PROCESS_SERVICE_CHECK_RESULT',
                        serviceUuid: this.uuids.serviceuuid,
                        hostUuid: this.uuids.hostuuid,
                        status_code:  this.checkForm.state,
                        plugin_output:  this.checkForm.comment,
                        long_output: ''
                    });
                }
            } */
            //this.$refs.togglePassiveCheck.click();
            this.$emit('command', externalCommands, 'submit');
            this.visible = false;
        },
    }
}
</script>

<style scoped>

</style>
